import Vue from 'vue'
import axios from 'axios'
import { VueAxios } from './axios'
import Router from '../../router'
import ElementUI from 'element-ui'

// 创建 axios 实例
const service = axios.create({
  baseURL: '/apis', // api base_url
  timeout: 6000 // 请求超时时间
})

const whiteUrlList = "'/login/authUser','/check/checkProject/queryById'";//白名单

const err = (error) => {
  if (error.response) {
    let data = error.response.data
    const token = localStorage.getItem('token');
    console.log("------异常响应------",token)
    console.log("------异常响应------",error.response.status)
    switch (error.response.status) {
      case 403:
        ElementUI.Message({
          message:"拒绝访问!",
          type:"warning"
        });
        break;
      case 500:
        ElementUI.Message({
          message:"Token失效，请重新登录!",
          type:"warning"
        });
        localStorage.clear();
        setTimeout(() => {
          Router.push('/login');
        }, 500);
        break;
      case 404:
        ElementUI.Message({
          message:"很抱歉，资源未找到!",
          type:"warning"
        });
        setTimeout(() => {
          Router.push('/login');
        }, 500);
        break;
      case 504:
        ElementUI.Message({
          message:"网络超时!",
          type:"warning"
        });
        break;
      case 401:
        ElementUI.Message({
          message:"未授权，请重新登录!",
          type:"warning"
        });
        localStorage.clear();
        setTimeout(() => {
         Router.push('/login');
        }, 500);
        break;
      default:
        ElementUI.Message({
          message:"系统提示："+data.message,
          type:"warning"
        });
        break
    }
  }
  return Promise.reject(error)
};

// request interceptor
service.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token && whiteUrlList.indexOf(config.url)<0) {
    config.headers['X-Access-Token'] = token;
  }
  return config
},(error) => {
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use((response) => {
  const token = localStorage.getItem('token');
  if (!token && whiteUrlList.indexOf(response.config.url)<0){
    localStorage.clear();
    setTimeout(() => {
      Router.push('/login');
    }, 500);
    return false;
  }
  if(!response.data) return false;
  if(response.data.code === 2001){
    ElementUI.Message({
      message:"口令失效, 请重新登录!",
      type:"warning"
    });
    Router.push('/login');
    return false
  }else{
    if(response.data.code !== 200){
      ElementUI.Message({
        message:response.data.msg,
        type:"warning"
      });
    }
    return response.data
  }
  }, err);

const installer = {
  vm: {},
  install (Vue, router = {}) {
    Vue.use(VueAxios, router, service)
  }
};

export  {
  installer as VueAxios,
  service as axios
}



// WEBPACK FOOTER //
// ./src/service/http/request.js